<template>
  <div class="contaner-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-2"><router-link  to="/">{{$t('property.breadcrumb_1')}}</router-link></li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="almarai-bold mx-2" aria-current="page">{{$t('property.breadcrumb_2')}}</li>
        <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active almarai-bold me-1" aria-current="page">{{$t('property.owner_controlPanel')}}</li>
      </ol>
    </nav>
  </div>
  <div  class="container pt-3">
    <!--begin: My Property-->
    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">
        <!-- <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('property.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="almarai-bold mx-3" aria-current="page">{{$t('property.breadcrumb_2')}}</li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active almarai-bold mx-3" aria-current="page">{{$t('property.owner_controlPanel')}}</li>
          </ol>
        </nav> -->
        <!-- <div class="row pt-2">
          <div class="col">
            <h5>{{$t('property.title_1')}}</h5>
          </div>
        </div> -->
        <div class="row py-2">
          <div class="col">
            <div v-if="hasError">
              <errorAlert :alertMessage="message" />
            </div>
          </div>
        </div>

        <div class="row" v-if="availableProperties.length || rentedProperties.length">
          <div class="col">
            <div class="card br-radius-16">
              <div class="card-body">
                <div class="row">
                  <div class="col content-center">
                    <span>
                      <img src="/assets/images/icons/container-1.png" class="max-28" alt="">
                    </span>
                    <span class="mx-2 almarai-bold">{{$t('property.propertyDetails')}}</span>
                  </div>
                  <div class="col-auto viewDoc">
                    <router-link to="/allProperties">
                      <span class="mx-2 ">{{$t('property.allProperties')}}</span>
                      <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                      <i  v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                    </router-link>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-12 col-md-4">
                    <div id="chart"></div>
                  </div>
                  <div class="col-11 col-md-7">
                    <div class="row pt-3 justify-content-center Advertisement">
                      <div class="col-12 col-md-8 advert">
                        <div class="card bg-redcard">
                          <div class="card-body p-2">
                            <div class="row">
                              <div class="col">
                                <div>
                                  <img src="/assets/images/icons/container.png" class="max-8" alt="">
                                  <span class="mx-2 text-black">{{$t('property.Sold')}}</span>
                                </div>
                              </div>
                              <div class="col-auto">
                                {{soldProperties.length}}
                              </div>
                              <div class="col-auto content-end pe-0">
                                <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                                <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-8  advert" v-if="rentedProperties.length">
                        <router-link to="/ownerProperties/?propertyType=rented">
                          <div class="card gold-card">
                            <div class="card-body p-2">
                              <div class="row">
                                <div class="col">
                                  <img src="/assets/images/icons/golden-circle.png" class="max-8" alt="">
                                  <span class="mx-1">{{$t('property.Landlord')}}</span>  
                                </div>
                                <div class="col-auto">
                                  {{rentedProperties.length}}
                                </div>
                                <div class="col-auto content-end pe-0">
                                  <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                                  <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>

                      <div v-else class="col-12 advert">
                        <div class="card bg-beige-FF">
                          <div class="card-body p-2">
                            <div class="row">
                              <div class="col">
                                <img src="/assets/images/icons/container-orange.png" class="max-8" alt="">
                                <span class="mx-1 text-black">{{$t('property.Landlord')}}</span>  
                              </div>
                              <div class="col-auto">
                                {{rentedProperties.length}}
                              </div>
                              <div class="col-auto content-end pe-0">
                                <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                                <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-8  advert" v-if="availableProperties.length">
                        <router-link to="/ownerProperties/?propertyType=availableProperties">
                          <div class="card bg-green">
                            <div class="card-body p-2">
                              <div class="row">
                                <div class="col">
                                  <img src="/assets/images/icons/container-green.png" class="max-8" alt="">
                                  <span class="mx-2 text-black">{{$t('property.vacancy')}}</span>
                                </div>
                                <div class="col-auto">
                                  {{availableProperties.length}}
                                </div>
                                <div class="col-auto content-end pe-0">
                                  <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                                  <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                      <div v-else class="col-12 col-md-8 advert">
                        <div class="card bg-green">
                          <div class="card-body p-2">
                            <div class="row">
                              <div class="col">
                                <img src="/assets/images/icons/container-green.png" class="max-8" alt="">
                                <span class="mx-2 text-black">{{$t('property.vacancy')}}</span>
                              </div>
                              <div class="col-auto">
                                {{availableProperties.length}}
                              </div>
                              <div class="col-auto content-end pe-0">
                                <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                                <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row pt-4">
              <div class="col">
                <div class="card br-radius-16">
                  <div class="card-body details-content">
                    <div class="row">
                      <div class="col content-center">
                        <span>
                          <img src="/assets/images/icons/container-2.png" class="max-28" alt="">
                        </span>
                        <span class="mx-2 almarai-bold">{{$t('property.rentalDetails')}}</span>
                      </div>
                      <!-- <div class="col-auto viewDoc">
                        <span class="mx-2">{{$t('property.viewDocuments')}}</span>
                        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1 font-12"></i>
                        <i v-else class="fa-solid fa-chevron-right pt-1 font-12"></i>
                      </div> -->
                    </div>

                    <div class="accordion totalRentalValue" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <div class="text-end">
                              <span class="font-12 gold-color-9E">{{$t('property.rentalValue')}}</span> <br>
                              <span class="font-30">
                                {{ Number(totalRentalValue).toLocaleString('en-US') }}
                                <img src="/assets/images/icons/R-black.png" class="max-12" alt="">
                                </span>
                            </div>
                            <!-- <div class="">{{totalRentalValue}}</div> -->
                          </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                          <div class="accordion-body p-2">
                            <div class="card card-collapse">
                              <div class="card-body p-0">
                                <div class="row" v-if="totalCollectedAmount">
                                  <div class="col gold-color-A7">
                                    {{$t('property.amountsCollected')}}
                                  </div>
                                  <div class="col-auto green-color-4C">
                                    <!-- {{totalCollectedAmount}} -->
                                    {{ Number(totalCollectedAmount).toLocaleString('en-US') }}
                                    <span class="ms-2">
                                      <img src="/assets/images/icons/R-green.png" class="max-12" alt="">
                                    </span>
                                  </div>
                                </div>
                                <hr class="gold-color" v-if="totalCollectedAmount">
                                <div class="row" v-if="totalDueAmount">
                                  <div class="col gold-color-A7">
                                    {{$t('property.amountsDue')}}
                                  </div>
                                  <div class="col-auto orange-color-F9">
                                    <!-- {{totalDueAmount}} -->
                                    {{ Number(totalDueAmount).toLocaleString('en-US') }}
                                    <span class="ms-2">
                                      <img src="/assets/images/icons/R-orange.png" class="max-12" alt="">
                                    </span>
                                  </div>
                                </div>
                                <hr class="gold-color" v-if="totalDueAmount">
                                <div class="row">
                                  <div class="col gold-color-A7">
                                    {{$t('property.overdueAmounts')}}
                                  </div>
                                  <div class="col-auto red-color-E0">
                                    <!-- {{totalRemainingAmount}} -->
                                    {{ Number(totalRemainingAmount).toLocaleString('en-US') }}
                                    <span class="ms-2">
                                      <img src="/assets/images/icons/R-red.png" class="max-12" alt="">
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pt-3 btn_propertyManagement">
                  <div class="col-10 col-md-3 text-center" v-if="accountManagers.length">
                    <a :href="'https://wa.me/+966'+parseInt(accountManagers[0].mobileNumber)" target="_blank">
                      <div class="contactManger">
                        <span class="mx-2">{{$t('property.contactManager')}}</span>
                        <img src="/assets/images/icons/calling.png" class="max-16" alt="">
                      </div>
                    </a>
                  </div>
                  <div class="col-10 col-md-3 text-center">
                    <router-link  to="/propertymanagement">
                      <div class="propertyManagement">
                        {{$t('property.title_1')}}
                        <i class="fa-solid fa-circle-plus mx-2"></i> 
                      </div>
                    </router-link>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        

        <div class="row pt-5" v-if="!availableProperties.length && !rentedProperties.length" >
          <div class="col">
            <div class="row justify-content-center">
              <div class="col-12 col-md-7 text-center">
                <div class="card bg-card-beige border-0">
                  <div class="card-body">
                    <img src="/assets/images/icons/pro.png" class="width-80"  alt="">
                    <!-- <h6 class="font-12">{{$t('property.property_title_1')}}</h6> -->
                    <div class="almarai-bold">{{$t('property.title_2')}}</div>
                    <div class="almarai-bold">{{$t('property.title_3')}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row justify-content-center pt-3">
              <div class="col-12 col-md-7">
                <h6>{{$t('property.property_title_3')}}</h6>
                <div class="row justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_1')}}</span>
                  </div>
                </div>

                <div class="row py-2 justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class=" mx-1 gray-50 font-12">{{$t('property.service_include_2')}}</span>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_3')}}</span>
                  </div>
                </div>

                <div class="row py-2 justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_4')}}</span>
                  </div>
                </div>

                <div class="row justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-24"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_5')}}</span>
                  </div>
                </div>
                <div class="row pt-2  justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_6')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_7')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_8')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_9')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0 text-center">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_10')}}</span>
                  </div>
                </div>

                <div class="row pt-2 justify-content-center">
                  <div class="col-auto p-0">
                    <div class="w-24">
                      <img src="/assets/images/icons/tick-circle.png" class="w-100"  alt="">
                    </div>
                  </div>
                  <div class="col-10 col-md-7 p-0">
                    <span class="mx-1 gray-50 font-12">{{$t('property.service_include_11')}}</span>
                  </div>
                </div>

                <div class="row pt-5 justify-content-center">
                  <!-- <div class="col-12 col-md-5">
                    <a href="">
                      <span>{{$t('property.contactManager')}}</span>
                      <img src="/assets/images/icons/calling.png" class="max-16" alt="">
                    </a>
                  </div> -->
                  <div class="col-11 col-md-5 text-center">
                    <router-link  to="/propertymanagement">
                      <div class="form-control btn-green">
                        <i class="fa-solid fa-circle-plus mx-2"></i> {{$t('property.title_1')}}
                      </div>
                    </router-link>
                  </div>
                </div>

                <div class="row pt-3">
                  <div class="col text-center">
                    <a href="https://wa.me/+966920016962?text= السلام عليكم أود التواصل مع أخصائى خدمة العملاء للاطلاع علي خدماتكم العقارية ومعرفة الخيارات المتاحة للتعاون وملاءمتها لاحتياجى الحالى. شكرًا لكم" target="_blank">
                      <div class="gold-color-A7">{{$t('property.btn_contactCustomer')}}</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <!--end: My Property-->

    <!--begin:modal login-->
    <div class="modal bg-modal" dir="rtl" tabindex="-1" id="formLogin">
      <div class="modal-dialog max-w">
        <div class="modal-content">
          <button type="button" class="btn-close m-2" @click.prevent="closeingFN" id="modal-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <!-- <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
          </div> -->
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col text-center">
                <div class="font-24 almarai-bold">{{$t('formLogin.title_1')}}</div>
                <p class="almarai-regular gray-color"> {{$t('formLogin.title_2')}} <br> {{$t('formLogin.title_3')}}</p>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-12 mb-2">
                <router-link to="/login">
                  <button class="login-btn rounded-pill form-control almarai-bold">{{$t('formLogin.title_4')}}</button>
                </router-link>
              </div>
              <div class="col-12">
                <router-link to="/register">
                  <button class="form-control rounded-pill p-2 createAccount" >
                    {{$t('formLogin.title_5')}} <span class="text-color extrabold ">{{$t('formLogin.title_6')}}</span>
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: "propertie",
  data(){
    return {
      hasError: false,
      message: "",
      isLoading: true,
      errorNumber: null,
      rows:[],
      icons: {},
      items: {},
      userLang: 'ar',
      containers: [],
      rentedProperties: [],
      soldProperties: [],
      availableProperties: [],
      accountManagers: [],
      totalRentalValue: null,
      totalCollectedAmount: null,
    }
  },

  computed: {
    ...mapGetters(['GET_USER', 'ISLOADING'])
  },

  methods: {
    getStatics(){
      this.isLoading = true;
      this.$http.get('/api/properties/statics').then(res => {
        this.rentedProperties = res.data.rentedProperties;
        this.soldProperties = res.data.soldProperties;
        this.availableProperties = res.data.availableProperties;
        this.totalRentalValue = res.data.totalRentalValue;
        this.totalCollectedAmount = res.data.totalCollectedAmount;
        this.totalDueAmount = res.data.totalDueAmount;
        this.totalRemainingAmount = res.data.totalRemainingAmount;
        this.accountManagers = res.data.accountManagers;
        this.isLoading = false;
        const totalPro = this.rentedProperties.length + this.soldProperties.length + this.availableProperties.length;
        var options = {
          series: [this.rentedProperties.length, this.soldProperties.length, this.availableProperties.length],
          labels: ['الموجر','المباع','المتاح'],
          colors:[ '#AA9359','#F4A0A0','#4CAF7D'],
          plotOptions: {
            pie: {
              donut: {
                size: '70%',
                labels: {
                  show: true,
                  total: {
                    show: true,
                    showAlways: true,
                    label: 'الاجمالي',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                    }
                  }
                }
              },
              customScale: 0.8
            }
          },
          // series: [
          //   {x: 'الاجمالي', y: totalPro}, 
          //   {x: 'الموجر', y: this.rentedProperties.length},
          //   // {}this.soldProperties.length, this.availableProperties.length
          //   ],
          chart: {
            // width: 380,
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                // chart: {
                //   width: 180,
                // },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 230,
          },
        }
        setTimeout(()=> {
          var chart = new ApexCharts(document.querySelector('#chart'), options)
          chart.render();
        },500)

      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },
    detectUser(){
      if(this.ISLOADING){
        setTimeout(() => this.detectUser(), 200);
      }else{
        if(this.GET_USER){
          this.getStatics();
        }else{
          this.isLoading = false;
        }
      }
    },

    // addFavorite(id, dataName, index){
    //   if(!this.GET_USER){
    //     document.getElementById('formLogin').style.display = "block";
    //     return false;
    //   }
    //   this.$http.post("/api/favorites/add",{
    //     propertyId: id,
    //   }).then(res => {
    //     // console.log(res);
    //     if(dataName == 'properties'){
    //       this.rows[index].Favorites = [{}];
    //     }
    //   }).catch(err => {
    //     // console.log(err);
    //     [this.message, this.errorNumber] = this.$globalError(err, true);
    //     this.hasError = true;
    //   });
    // },

    // removeFavorite(id, dataName, index){
    //   if(!this.GET_USER){
    //     document.getElementById('formLogin').style.display = "block";
    //     return false;
    //   }
    //   this.$http.delete("/api/favorites/remove/"+id).then(res => {
    //     // console.log(res);
    //     if(dataName == 'properties'){
    //       this.rows[index].Favorites = [];
    //     }
    //   }).catch(err => {
    //     console.log(err);
    //   });
    // },
  },
  created(){
    this.detectUser();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top : 'behavior'});
  },
}
</script>